import React, { useState } from 'react';
import { Draggable } from 'components/drag-and-drop';
import { Brikk } from 'components/Brikk';
import { SeeMoreButton } from 'components/form-elements/buttons/SeeMoreButton';
import { UsersIcon } from 'assets/icons/UsersIcon';
import { BrikkModal } from 'components/modals/BrikkModal';
import { useAllUsers } from '../../../../services/admin/get-all-users';
import { UserAdministrationPreview, UserAdministrationModal } from './components';

export const UserAdministration = ({ position, status, code, name }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isLoading } = useAllUsers();

  return (
    <>
      <Draggable position={position}>
        <Brikk
          isLoading={isLoading}
          brikkKey={code}
          name={name}
          status={status}
        >
          <Brikk.Header
            icon={<UsersIcon />}
            heading="userAdminBrikk"
            brikkKey={code}
            status={status}
          />

          <Brikk.Content center>
            <UserAdministrationPreview />
          </Brikk.Content>

          <Brikk.Button>
            <SeeMoreButton
              onClick={() => setIsModalOpen(true)}
              brikkNameIntl="userAdminInfo"
            />
          </Brikk.Button>
        </Brikk>
      </Draggable>
      <BrikkModal
        isOpen={isModalOpen}
        heading="reportIssueInfo"
        onClose={() => setIsModalOpen(false)}
      >
        <UserAdministrationModal />
      </BrikkModal>
    </>
  ); 
};
